import { Col, Image, Row } from 'antd';
import { useTranslation } from 'react-i18next';

import StyledCard from 'components/styled-card';
import { NightlyResponse } from 'types/hcp/pdfreport.type';

const Poincare = ({ nightly }: { nightly: NightlyResponse }) => {
  const { t } = useTranslation();
  return (
    <StyledCard id="poincare" title={t('nightly.poincare')}>
      <Row gutter={[16, 16]}>
        <Col xs={{ span: 24 }} md={{ span: 12 }} lg={{ span: 24 }} xl={{ span: 24 }}>
          <div className="bar-container">
            <Image preview={false} src={nightly?.images?.poincare} />
          </div>
        </Col>
      </Row>
    </StyledCard>
  );
};

export default Poincare;
